var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Edit icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.03553 14.9972H2.5V11.4617L12.0292 1.93255C12.3547 1.60712 12.8822 1.60712 13.2077 1.93255L15.5647 4.28958C15.8902 4.61501 15.8902 5.14265 15.5647 5.46808L6.03553 14.9972ZM2.5 16.6639H17.5V18.3306H2.5V16.6639Z",
    fill: "#006399"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/Edit_icon.481a081fe5cee516aac8b1c23a9858b0.svg";
export { ForwardRef as ReactComponent };